import { create } from 'zustand';

export const useApiErrorStore = create((set, get) => ({
  type: null,
  message: '',
  retryAfter: null,
  endTime: null,

  setRateLimit: ({ message, retryAfter, endTime }) =>
    set({
      type: 'RATE_LIMIT',
      message,
      retryAfter,
      endTime,
    }),

  clearError: () =>
    set({
      type: null,
      message: '',
      retryAfter: null,
      endTime: null,
    }),

  isRateLimited: () => {
    const { endTime } = get();
    return !!endTime && endTime > Date.now();
  },

  getRemainingSeconds: () => {
    const { endTime } = get();
    if (!endTime) return 0;
    return Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
  },
}));
